import { createEnum } from '@ts-max/enum';

export const envEnum = createEnum({
  DEVELOPMENT: ['development', '开发环境'],
  PRODUCTION: ['production', '生产环境'],
  PREVIEW: ['preview', '预生产环境'],
  TEST: ['test', '测试环境'],
  RC: ['rc', '预发环境'],
});
